"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGenericTextConfig = exports.ALL_GENERIC_TEXT_TYPES = exports.ALL_HEADINGS = exports.HEADING_NUMBERS = void 0;
var classnames_1 = __importDefault(require("classnames"));
var textStyles_1 = require("../Traits/Styleable/textStyles");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var react_1 = __importDefault(require("react"));
var GenericTextComponent_1 = require("@CommonFrontend/Public/Widgets/GenericText/GenericTextComponent");
exports.HEADING_NUMBERS = ["1", "2", "3", "4"];
exports.ALL_HEADINGS = exports.HEADING_NUMBERS.map(function (n) { return "heading".concat(n); });
exports.ALL_GENERIC_TEXT_TYPES = __spreadArray(__spreadArray([], __read(exports.ALL_HEADINGS), false), ["paragraph", "smallText", "captionText"], false);
function makeGenericTextConfig(type, htmlTag, css, defaults, styleKey) {
    var _a, _b;
    if (!styleKey) {
        styleKey = htmlTag;
    }
    var lineHeightSuggestions = buildLineHeightSuggestions(defaults.lineHeight);
    return {
        type: type,
        tokenType: {},
        publicRenderHtmlString: function (_a) {
            var attributes = _a.attributes, innerHtml = _a.innerHtml, computeForegroundColor = _a.computeForegroundColor, style = _a.style;
            if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
                innerHtml = "<br />";
            }
            var styleString = (0, textStyles_1.generateStyleStringFromObject)(__assign(__assign({}, attributes.style), (0, textStyles_1.maybeAssignComputedForegroundColor)({
                computeForegroundColor: computeForegroundColor,
                foregroundStyle: style,
                foregroundColorVar: css.vars.color,
            })));
            return "<".concat(htmlTag, " class=\"").concat(attributes.className, " ").concat(css.widget, "\" style=\"").concat(styleString, "\">").concat(innerHtml, "</").concat(htmlTag, ">");
        },
        publicRenderReactNode: function (_a) {
            var attributes = _a.attributes, style = _a.style, childTokens = _a.childTokens;
            return react_1.default.createElement(GenericTextComponent_1.GenericTextComponent, {
                attributes: attributes,
                style: style,
                htmlTag: htmlTag,
                css: css,
                childTokens: childTokens,
            });
        },
        traits: {
            spacingShim: {
                className: (0, classnames_1.default)("".concat(styleKey, "-widget__spacing-shim"), css.spacingShim),
            },
            widgetId: {},
            styleable: {
                styleKey: styleKey,
                properties: [
                    {
                        type: "fontFamily",
                        variable: css.vars.fontFamily,
                        path: "fontFamily",
                        label: "Font",
                        defaultValue: { fontStyleType: commonTypes_1.FontStyleType.Brand, brandFontRef: defaults.brandFontRef },
                    },
                    {
                        type: "fontWeight",
                        variable: css.vars.fontWeight,
                        path: "fontWeight",
                        label: "Font weight",
                        defaultValue: defaults.fontWeight,
                    },
                    {
                        defaultValue: defaults.textColor,
                        label: "Text color",
                        path: "color",
                        type: "color",
                        variable: css.vars.color,
                    },
                    {
                        defaultValue: { abs: defaults.fontSize, themeRef: null },
                        label: "Font Size",
                        max: 400,
                        min: 14,
                        path: "size",
                        type: "fontSize",
                        variable: css.vars.fontSize,
                    },
                    {
                        defaultValue: "left",
                        label: "Alignment",
                        path: "alignment",
                        type: "alignable",
                        variable: css.vars.alignment,
                    },
                    {
                        defaultValue: defaults.lineHeight,
                        label: "Line height",
                        path: "lineHeight",
                        type: "numerical",
                        variable: css.vars.lineHeight,
                        min: 1,
                        max: 3,
                        stepSize: 0.1,
                        withSlider: false,
                        suggestedOptions: lineHeightSuggestions,
                    },
                    {
                        defaultValue: 0,
                        label: "Letter spacing",
                        path: "letterSpacing",
                        type: "numerical",
                        variable: css.vars.letterSpacing,
                        min: -0.2,
                        max: 1,
                        stepSize: 0.01,
                        withSlider: false,
                        suffix: "em",
                        suggestedOptions: [-0.02, 0, 0.02].map(function (v) {
                            return { value: v };
                        }),
                    },
                    {
                        defaultValue: "none",
                        label: "Letter case",
                        path: "letterCase",
                        options: [
                            {
                                applies: [{ variable: css.vars.letterCase, value: "none" }],
                                label: "Ag",
                                value: "none",
                            },
                            {
                                applies: [{ variable: css.vars.letterCase, value: "uppercase" }],
                                label: "AG",
                                value: "uppercase",
                            },
                        ],
                        type: "enumerable",
                    },
                    {
                        type: "numerical",
                        variable: css.vars.blockSpacing.before,
                        path: "blockSpacing.before",
                        label: "Top spacing",
                        min: 0,
                        max: 20,
                        stepSize: 0.1,
                        withSlider: false,
                        defaultValue: (_a = defaults.blockSpacing.before) !== null && _a !== void 0 ? _a : 0,
                        suffix: "em",
                    },
                    {
                        type: "numerical",
                        variable: css.vars.blockSpacing.after,
                        path: "blockSpacing.after",
                        label: "Bottom spacing",
                        min: 0,
                        max: 20,
                        stepSize: 0.1,
                        withSlider: false,
                        defaultValue: (_b = defaults.blockSpacing.after) !== null && _b !== void 0 ? _b : 0,
                        suffix: "em",
                    },
                ],
            },
            constrainInLayout: {}
        },
    };
}
exports.makeGenericTextConfig = makeGenericTextConfig;
var baseLineHeightSuggestions = [1, 1.15, 1.5, 2];
function buildLineHeightSuggestions(defaultValue) {
    var suggestions = __spreadArray([], __read(baseLineHeightSuggestions), false);
    if (!suggestions.includes(defaultValue)) {
        suggestions.push(defaultValue);
    }
    suggestions.sort(function (a, b) { return a - b; });
    return suggestions.map(function (v) {
        return { value: v, displayName: v === defaultValue ? "".concat(v, " (default)") : undefined };
    });
}
